import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center justify-center" aria-label="Engramiq Logo">
      <img
        src={process.env.PUBLIC_URL + '/LOGO MARK AND TYPE - CMYK-02 (1).png'}
        alt="Engramiq Logo"
        className="w-[300px] h-auto object-contain"
      />
    </div>
  );
};

export default Logo;
